import { ref, watch } from 'vue';

/**
 * Thème clair / sombre / système, mémorisé dans le navigateur et appliqué au
 * <html> (classe `dark`, que le preset Tailwind d'Altonéo écoute).
 *
 * Appliqué AU DÉMARRAGE (`initPreferences`, dans main.ts, avant le montage) :
 * sinon la page s'afficherait une fraction de seconde en clair avant de
 * basculer, ce qui se voit — surtout le soir, sur téléphone.
 */
export type ThemePreference = 'clair' | 'sombre' | 'systeme';

const THEME_KEY = 'igd.theme';

function lireTheme(): ThemePreference {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === 'clair' || v === 'sombre' || v === 'systeme' ? v : 'systeme';
  } catch {
    return 'systeme';
  }
}

export const themePreference = ref<ThemePreference>(lireTheme());

function prefereSombre(): boolean {
  return typeof matchMedia !== 'undefined' && matchMedia('(prefers-color-scheme: dark)').matches;
}

export function estSombre(): boolean {
  const t = themePreference.value;
  return t === 'sombre' || (t === 'systeme' && prefereSombre());
}

function appliquerTheme(): void {
  document.documentElement.classList.toggle('dark', estSombre());
}

let ecouteOs = false;

export function initPreferences(): void {
  appliquerTheme();
  // Le mode « système » suit l'OS en direct (bascule automatique jour/nuit).
  if (!ecouteOs && typeof matchMedia !== 'undefined') {
    ecouteOs = true;
    matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (themePreference.value === 'systeme') appliquerTheme();
    });
  }
}

export function setTheme(v: ThemePreference): void {
  themePreference.value = v;
}

watch(themePreference, (v) => {
  try {
    localStorage.setItem(THEME_KEY, v);
  } catch {
    /* préférence non persistée : sans gravité */
  }
  appliquerTheme();
});
